import Vue from 'vue'

// axios
import axios from 'axios'

const axiosIns = axios
  .create({
    baseURL: process.env.VUE_APP_ROOT_API,
    // Ensure requests that never get a response (hung backend, dropped
    // connection, etc.) always eventually reject instead of leaving
    // loading states stuck forever.
    timeout: 30000,
    // headers: { 'X-Custom-Header': 'foobar' },
  })

Vue.prototype.$http = axiosIns

export default axiosIns
